import { BaseComment } from '../../../../../../models/base/base-comment';
import { CommentMention } from '../../../../../../models/base/comment-mention';

export class MemberRecordComment extends BaseComment {
  public memberId!: string;
  public mentions: CommentMention[] = [];
}
